import { Component, OnInit } from '@angular/core';
import { IShop, Shop } from '../../../../../../models/shop.model';
import { IPost } from '../../../../../../models/post.model';
import { Category, ICategory } from '../../../../../../models/category.model';
import { Characteristics, ICharacteristics } from '../../../../../../models/characteristics.model';
import { IProductType, ProductType } from '../../../../../../models/productType.model';
import { IProductSubType, ProductSubType } from '../../../../../../models/productSubType.model';
import { IProductCharacteristic } from '../../../../../../models/productCharacteristic.model';
import { IProductProductSubType } from '../../../../../../models/productProductSubType.model';
import { ITripExpenseService } from '../../../../../../models/tripExpenseService.model';
import { ITripExpense, TripExpense } from '../../../../../../models/tripExpense.model';
import { ShopService } from '../../../../../../services/shop.service';
import { FormBuilder, FormControl, Validators, FormArray, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import Swal from 'sweetalert2';
import { environment } from '../../../../../../environments/environment';
import { SubProduct } from '../../../../../../models/subProduct.model';
import { SubProductCharacteristic } from '../../../../../../models/subProductCharacteristic.model';
import { EncryptionService } from '../../../../../../services/EncryptionService';
import { CategoryService } from '../../../../../../services/category.service';
import { CharacteristicsService } from '../../../../../../services/characteristics.service';
import { ProductService } from '../../../../../../services/product.service';
import { ProductTypeService } from '../../../../../../services/productType.service';
import { NameValidator } from '../../../../validators/name.validator';

@Component({
  selector: 'app-add-pass',
  templateUrl: './add-pass.component.html',
  styleUrls: ['./add-pass.component.scss']
})
export class AddPassComponent implements OnInit {
  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }
  // shop: IShop[] = [];
  //   type:any;
  //   isVetement= false;
  //   isOther= false;
  //   p = 1;
  //   url_photo:any;
  //   allProducts: IProduct[] =[];
  //   allProductsTmp: IProduct[] =[];
  //   post: IPost[] =[];
  //   // @ts-ignore
  //   public modalRef: BsModalRef;
  //   page:number=1;
  //   // @ts-ignore
  //   pages:Array<number>;
  //   categoryWithGiftCard:ICategory[] = [];
  //   categories:ICategory[]=[];
  //   shops:IShop[]=[];
  //   // @ts-ignore
  //   mycharacteristics:ICharacteristics= [];
  //   // @ts-ignore
  //   myProductSubType:IProductSubType= [];

  //   // @ts-ignore
  //   mySubCharacteristics:ICharacteristics= [];
  //   characteristics:ICharacteristics[]=[];
  //   productTypes:IProductType[]=[];
  //   productSubs:ProductSubType[]=[];
  //   // @ts-ignore
  //   myproductTypes:IProductType=[];
  //   productcharacteristics:IProductCharacteristic[]=[];
  //   productSubcharacteristics:IProductCharacteristic[]=[];

  //   productsubType: IProductProductSubType[]=[];
  //   myproductcharacteristics:IProductCharacteristic[]=[];
  //   myproductSubcharacteristics:IProductCharacteristic[]=[];
  //   myproductsubType: IProductProductSubType[]=[];
  //   // @ts-ignore
  //   myproductsubTypeoBJECT: IProductSubType=[];
  //   myproductsubType2: IProductProductSubType[]=[];

  //   photoProduit: string = "";
  //   photoProduit1: string = "";
  //   photoProduit2: string = "";
  //   photoSousProduit: string = "";
  //   filtred:IProduct[]=[];
  //   filter = false;
  //   allProduct:IProduct[]=[];
  //   sorted = false;
  //   sorted1 = false;
  //   sorted2 = false;
  //   sorted3 = false;
  //   sorted4 = false;
  //   sorted5 = false;
  //   tripExpenseList:ITripExpenseService[]=[];
  //   tripExpenseService:ITripExpenseService[]=[];
  //   myTripExpense:ITripExpenseService[]=[];
  //   productQuantity:number = 0;
  //   productQuantityUpdated:number = 0;
  //   trip_ExpenseModel: ITripExpense[] =[];
  //   /*Product subtype infos */
  //   showProductSubType = false;
  //   showProductSubTypeButton = true;
  //   showCharacteristicProduct = false;
  //   showProductTripExpense = false;
  //   productSubTypeCharacteristics: any[] = [];
  //   productTripeExpenses: any[] = [];
  //   productSubTypesForm: any[] = [];
  //   productSubTypeCharacteristicsForm:any[] = [];
  //   productSubTypeForms:any[] = [];
  //   productSubtypeArrayTampon: any[] = [];
  //   productSubTypesSaved:SubProduct[] = [];
  //   ishiddenDeliveryDdelay:boolean = false;
  //   /*End product subtype infos*/
  //   isTrueName = false;
  //   isTrueSubProdName = false;
  //   //productDeliveryZonesList:IProductDeliveryZones[]=[];

  //   disableButtonValider : boolean = false;

  //   products: IProduct[] = [];

  //   perPage: number = 10;
  //   totalItems: number = 1000;
  //   currentPage: number = 1;
  //   totalPages!: number;
  //   caracteristiquesVariante:any[]=[];
  //   caracteristiquesVarianteTmp:any[]=[];
  //   // @ts-ignore
  //   user: IUser = [];
  //  // allAUserZones: UserZone[] = [];
  //   constructor(
  //               private shopService: ShopService,private router:Router,
  //               private productService: ProductService,
  //               private modalService: BsModalService,
  //               private producttypeService:ProductTypeService,
  //               private characteristicsService:CharacteristicsService,
  //               private categoryService:CategoryService,
  //               private fb :FormBuilder,
  //               private produitService:ProductService,
  //               //private sharedSevice: SharedFonctionsService,
  //               private encryptionService: EncryptionService) {
  //     this.type=[
  //       {id: 1, text: 'Vetement'},
  //       {id: 2, text: 'Autres'}
  //   ];
  // }

  // deliveryDdelayType:any=[{"id" : "1", "name" : "Minutes"},{"id" : "2", "name" : "Heures"},{"id" : "3", "name" : "Jours"},{"id" : "4", "name" : "Mois"}];

  // ngOnInit(): void {
  //   this.url_photo=environment.url_photo;
  //   this.loadProduct_v1();
  //   this.loadPublishProduct();
  //   this.loadShop();
  //   // this.loadCategory();
  //   //this.loadCharacteristic();
  //   this.loadProductSubType();
  //   this.loadTripExpense();
  //   this.loadPersonalInformation();
  // }

  // numberOnly(event: { which: any; keyCode: any; }): boolean {
  //   const charCode = (event.which) ? event.which : event.keyCode;
  //   if (charCode > 31 && (charCode < 48 || charCode > 57)) {
  //     return false;
  //   }
  //   return true;
  // }


  // // loadArea() {
  // //   this.userZoneService.getUserZonzByUsername(this.user?.username).subscribe((data: any) => {
  // //     this.allAUserZones = data;
  // //     // console.log("Liste des zones de livraisons");
  // //     // console.log(this.allAUserZones);
  // //   }, (err) => {
  // //     // console.log('-----> err', err);
  // //   });
  // // }

  // // Only AlphaNumeric
  // keyPressAlphanumeric(event) {
  //   var inp = String.fromCharCode(event.keyCode);
  //   if (!/[!@#$%°£§^&*$()_+\=\[\]{};:"\\|,.<>\/?]/.test(inp)) {
  //     return true;
  //   } else {
  //     event.preventDefault();
  //     return false;
  //   }

  // }

  // // Rechercher si le vendeur a déjà un produit en ce nom
  // getIfProductNameExist(nameTampon?: any): boolean{
  //   let testName = nameTampon.target.value;
  //   var testbool = true;
  //   this.allProduct.forEach(element =>{
  //     if(testbool){
  //       if(element.name){
  //         if(element.name.toUpperCase() === testName.toUpperCase()){
  //           testbool = false;
  //           this.isTrueName = true;
  //         }else{
  //           this.isTrueName = false;
  //         }
  //       }
  //     }
  //   })
  //   return this.isTrueName;
  // }

  // getEditedProduct(prod : IProduct){
  //   const data  = undefined ? '' : JSON.stringify(prod.product_type?.id);
  //   const datacryt = this.encryptionService.encryptionAES(data);
  //   window.localStorage.setItem('khshprodd',datacryt);
  //   this.sharedSevice.produitPartagee = prod;
  // }

  // // Rechercher si le vendeur a déjà un produit en ce nom
  // getIfProductSubtypeNameExist(nameTampon?: any): boolean{
  //   let testName = nameTampon.target.value;
  //   var testbool = true;
  //   this.allProduct.forEach(element =>{
  //     if(element.subProducts){
  //       if(element.subProducts.length>0){
  //         element.subProducts.forEach(elementAt =>{
  //           if(testbool){
  //             if(elementAt.name){
  //               if(elementAt.name.toUpperCase() === testName.toUpperCase()){
  //                 testbool = false;
  //                 this.isTrueSubProdName = true;
  //               }else{
  //                 this.isTrueSubProdName = false;
  //               }
  //             }
  //           }
  //         })
  //       }
  //     }
  //   })
  //   return this.isTrueName;
  // }

  // /**
  //  * Récupérer ici la quantité que du produit de base
  // */
  // saveQuantity=(val: any)=>{
  //   let index = parseInt(val.target.value);
  //   this.productQuantity = Number(index);
  //   // alert(this.productQuantity);
  //   return true;
  // }
  // /**
  //  * Récupérer le seuil du produit de base
  // */
  // seuilProd = 0;
  // testSeuilProd=false;
  // saveSeuil=(val: any)=>{
  //   let index = parseInt(val.target.value);
  //   this.seuilProd = Number(index);
  //   if(this.seuilProd > this.productQuantity){
  //     this.testSeuilProd = true;
  //     this.productFormDis = true;
  //   }else{
  //     this.testSeuilProd = false;
  //     this.productFormDis = false;
  //   }
  // }
  // /**
  //  * Récupérer et contrôler le seuil de sous-produit
  // */
  // seuilSubProd = 0;
  // testSeuilSubProd=false;
  // saveSubProdSeuil=(val: any)=>{
  //   let index = parseInt(val.target.value);
  //   this.seuilSubProd = Number(index);
  //   if(this.seuilSubProd > this.quantity){
  //     this.testSeuilSubProd = true;
  //     this.subProductFormDis = true;
  //   }else{
  //     this.testSeuilSubProd = false;
  //     this.subProductFormDis = false;
  //   }
  // }

  // /**
  //  * Quand on change les caractéristiques d'un produit
  // */
  // enableCharacteristicValue = false;
  //  caracteristicsChanged(val: any){
  //   let index = val.target.value;
  //   if(index){
  //     this.enableCharacteristicValue = true;
  //   }
  //  }

  // updateQuantity=(val: any)=>{
  //   let index = parseInt(val.target.value);
  //   this.productQuantityUpdated = this.productQuantity+index;
  //   // if(this.productQuantityUpdated>this.productQuantity){
  //   //   Swal.fire({
  //   //     position: 'top-end',
  //   //     icon: 'error',
  //   //     title: 'La quantité de votre sous type ne doit pas être supérieur à la quantité total',
  //   //     showConfirmButton: false,
  //   //     timer: 1500
  //   //   })
  //   // }
  //   return true;
  // }


  // search: any;

  // loadTripExpense = () => {
  //   let tabZoneRemoveRedondance : any = [];
  //   this.trip_ExpenseService.getTripExpense(0,200).subscribe((data :any)=>{
  //     data.content.forEach((element:any) => {
  //       if(element.zone != null && !tabZoneRemoveRedondance.includes(element.zone.id))
  //       {
  //         tabZoneRemoveRedondance.push(element.zone.id);
  //         this.trip_ExpenseModel.push(element);
  //       }
  //     });
  //   })
  //   // console.log("🔥🔥🔥🔥🔥🔥🔥🔥🌹🌹 listeTripExpenses 🌹🌹🔥🔥🔥🔥🔥🔥🔥🔥");
  //   // console.log(this.trip_ExpenseModel);
  // };

  // onFilter() {
  //   if(!this.filter) {
  //     this.filter = true;
  //   }
  //   else {
  //     this.filter = false;
  //     this.search = "";
  //     this.loadProduct_v1();
  //   }
  // }
  // mesPublications()
  // {
  //   this.router.navigate(["/mes-publications"]).then(() => {
  //     // this.reloadComponent();
  //   });
  // }

  // isSearch = false;
  // searchFilter($event: KeyboardEvent) {
  //   this.isSearch = true;
  //   this.search = this.search.toString().toLowerCase();
  //   this.allProducts = this.sortProductsByDate(
  //     this.allProductsTmp.filter(
  //       value => value.name?.toLowerCase().includes(this.search) || value.category?.name?.toLowerCase().includes(this.search) || value.productID?.toLowerCase().includes(this.search) || value.shop?.name?.toLowerCase().includes(this.search) || value.shop?.shopID?.toLowerCase().includes(this.search)
  //       || value.name?.toLowerCase().includes(this.search) || value.category?.name?.toLowerCase().includes(this.search) || value.productID?.toLowerCase().includes(this.search) || value.shop?.name?.toLowerCase().includes(this.search) || value.shop?.shopID?.toLowerCase().includes(this.search)
  //       || value.name?.includes(this.search) || value.category?.name?.includes(this.search) || value.productID?.includes(this.search) || value.shop?.name?.includes(this.search) || value.shop?.shopID?.includes(this.search) || value?.product_type?.name?.toLowerCase().includes(this.search)
  //   ));
  // }

  // sortProductsByDate(products: Product[]): Product[] {
  //   return products.sort((a, b) => {
  //     if (a.createdAt && b.createdAt) {
  //       const dateA = new Date(a.createdAt);
  //       const dateB = new Date(b.createdAt);
  //       return dateB.getTime() - dateA.getTime();
  //     } else {
  //       return 0;
  //     }
  //   });
  // }


  // boutiquePage()
  // {
  //   this.router.navigate(["/boutique"]).then(() => {
  //     // window.location.reload();
  //   });
  // }
  // loadCharacteristic= () => {
  //   this.characteristicsService.query(0,200).
  //   subscribe((data :any)=>{
  //     data.content.forEach((element:any) => {
  //       this.characteristics.push(element);
  //     });
  //   })
  // };
  // loadProductSubType= () => {
  //   this.producttypeService.queryproduct(0,200).
  //   subscribe((data :any)=>{
  //     data.content.forEach((element:any) => {
  //       this.productSubs.push(element);
  //       // console.log(this.productSubs)
  //     });
  //   })
  //   // console.log("LISTE DES SOUS TYPE DE PRODUITS");
  //   // console.log(this.productSubs);
  // };
  // loadPublishProduct = () => {
  //   this.productService.getPublishProduct(this.page, this.perPage).
  //   subscribe((data :any)=>{
  //     this.post=data;
  //     // console.log("#####~~~~~ publish ~~~~~#####")
  //     // console.log(this.post);
  //     // console.log("#####~~~~~ publish ~~~~~#####")
  //   })
  // };

  // loadProduct_v1 = () => {
  //   this.allProduct= [];
  //   this.filtred = [];
  //   this.productService.loadProduct_v1(0,200).subscribe((data :any)=>{
  //     // console.log("Liste des produits");
  //     // console.log(data.content);
  //     this.allProducts = data.content;
  //     this.allProductsTmp = data.content;
  //   })
  // };


  // // loadProduct = () => {
  // //   let listeProductRemoveRedondance : any[] = [];
  // //   this.allProduct= [];
  // //   this.filtred = [];
  // //   this.productService.loadProduct_v1(0,200).subscribe((data :any)=>{
  // //     console.log("Liste des produits");
  // //     console.log(data.content);
  // //     this.allProducts = data.content;
  // //     data.content.forEach((element:any) => {
  // //       if (!listeProductRemoveRedondance.includes(element.productID)) {
  // //         listeProductRemoveRedondance.push(element);
  // //       }
  // //     });
  // //     this.product = this.sortProductsListByDate(listeProductRemoveRedondance);
  // //     this.productTmp = this.sortProductsListByDate(listeProductRemoveRedondance);
  // //     this.allProduct = this.sortProductsListByDate(listeProductRemoveRedondance);
  // //     this.filtred = this.sortProductsListByDate(listeProductRemoveRedondance);
  // //   })
  // // };

  // sortProductsListByDate(productsList :any[]) :IProduct[]{
  //   return productsList.sort((a, b) => {
  //     const dateA = new Date(a.createdAt).getTime();
  //     const dateB = new Date(b.createdAt).getTime();
  //     return dateB - dateA;
  //   });
  // }

  // loadShop = () => {
  //   this.shopService.query(0, 200).
  //   subscribe((data) => {
  //     data.content.forEach((element: any) => {
  //       this.shop.push(element);
  //     });
  //   })
  // };

  // EditProduit(prod:IProduct) {
  //   console.log(prod)
  //   this.modalRef = this.modalService.show(EditProduitComponent,{
  //       initialState:{prod},
  //       backdrop:false,
  //       ignoreBackdropClick:true
  //   });
  // }

  // DeleteProduit(prod:IProduct){
  //   Swal.fire({
  //     title: 'Voulez-vous vraiment supprimer ce produit ?',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonText: 'Non',
  //     confirmButtonText: 'Oui'
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       this.produitService.deleteProduct(prod).subscribe(
  //         rs=> {

  //           // console.log("Response de la suppression")
  //           // console.log(rs)
  //           Swal.fire({
  //             position: 'top-end',
  //             icon: 'success',
  //             title: 'Votre produit est supprimé de la liste avec succès.',
  //             showConfirmButton: false,
  //             timer: 1500
  //           });
  //           this.loadProduct_v1();
  //           this.reloadComponent();
  //         }, error => {
  //           // console.log(error);
  //           Swal.fire({
  //             position: 'top-end',
  //             icon: 'error',
  //             title: error.error.errorMessage,
  //             showConfirmButton: false,
  //             timer: 5500
  //           })
  //         }
  //       )
  //     }
  //   })

  // }
  // detailsProduit(prod:IProduct) {
  //   this.modalRef = this.modalService.show(DetailsProduitListComponent,
  //     {
  //       initialState:{prod},
  //       backdrop:false,
  //       ignoreBackdropClick:true
  //     });
  // }

  // // annonceProduit(prod:IProduct){
  // //   this.modalRef = this.modalService.show(AnnoncesProduitComponent,
  // //     {
  // //       initialState:{prod},
  // //       backdrop:false,
  // //       ignoreBackdropClick:true
  // //     });
  // //   this.modalRef.content.saveEvent.subscribe((resp:any)=>this.loadProduct())
  // // }

  // onChange(newValue:any) {
  //   // console.log(newValue.target.value);
  //   //vente
  //   if(newValue.target.value==1)
  //   {
  //     this.isVetement= true;
  //     this.isOther=false;
  //   }
  //   //Autres
  //   if(newValue.target.value==2)
  //   {
  //     this.isVetement= false;
  //     this.isOther=true;
  //   }
  // }

  // loadShopCategory = (val:any)=>{
  //   let index = parseInt(val.target.value);
  //   let shopName: IShop;
  //   this.shopService.getIdShop(index).subscribe(rs=>{
  //     shopName = rs;
  //     if(shopName.name=="Kahpoo" && shopName.id == index){
  //       this.loadCategory();
  //     }else{
  //       this.loadCategoryWithoutGiftCard();
  //     }
  //   })
  // }

  // selectedCategory: any;
  // selectedSubCategory: any;
  // loadSubCategory(val: any){
  //   let index = parseInt(val.target.value);
  //   this.selectedCategory = val.target.value;
  //   this.productService.getProductCategorySubType(Number(index)).subscribe(data=>{
  //     this.productTypes = data;
  //     // console.log(this.productTypes)
  //   });
  // }

  // loadCategory= () => {
  //   this.categories = [];
  //   this.categoryService.query(0,200).subscribe((data :any)=>{
  //     data.content.forEach((element:any) => {
  //       this.categories.push(element);
  //     });
  //   })
  // };


  // loadCategoryWithoutGiftCard= () => {
  //   this.categories = [];
  //   this.categoryWithGiftCard = [];
  //   let categoriesTampon:any[] = [];
  //   this.categoryService.query(0,200).
  //   subscribe((data :any)=>{
  //     data.content.forEach((element:any) => {
  //       categoriesTampon.push(element);
  //     });
  //     categoriesTampon.forEach(element => {
  //       this.categoryWithGiftCard.push(element);
  //     });
  //     for(let index in this.categoryWithGiftCard){
  //       if(this.categoryWithGiftCard[index].name==="Carte cadeaux"){
  //         this.categoryWithGiftCard.splice(Number(index),1);
  //         this.categoryWithGiftCard = [...this.categoryWithGiftCard];
  //       }
  //     }
  //     this.categories = this.categoryWithGiftCard;
  //   })
  // };

  // /**
  //  * Controler le type d'image ainsi que leur taille
  //  * @param event
  //  */
  // selectFile00(event: any) {
  //   var mimeType = event.target.files[0].type;
  //   var sizeFile=event.target.files[0].size;
  //   if(!event.target.files[0] || event.target.files[0].length == 0) {
  //     this.msg00 = 'Selectionner une photo';
  //   }
  //   // console.log("size!!!!!")
  //   // console.log(sizeFile)
  //   if(sizeFile<2000000){
  //     // console.log(mimeType);
  //     if (mimeType=="image/jpeg"||mimeType=="image/jpg"||mimeType=="image/png") {
  //       var reader = new FileReader();
  //       reader.readAsDataURL(event.target.files[0]);
  //       reader.onload = (_event) => {
  //         this.msg00 = "";
  //         this.test00 = true;
  //         // alert(this.test)
  //         this.url00 = reader.result;
  //         this.photoProduit = this.url00;
  //         // console.log( this.url00);
  //       }
  //     }else{

  //       // this.msg = "Ce type de fichier n'est pas pris en compte.";
  //       var reader = new FileReader();
  //       reader.readAsDataURL(event.target.files[0]);
  //       reader.onload = (_event) => {
  //         this.msg00 = "Ce type de fichier n'est pas pris en compte.";
  //         this.url00 = reader.result;
  //         this.test00 = false;
  //       }
  //     }
  //   }else{
  //     // this.msg = "la taille de l'image est trop grande";
  //     var reader = new FileReader();
  //       reader.readAsDataURL(event.target.files[0]);
  //       reader.onload = (_event) => {
  //         this.msg00 = "La taille de l'image est trop grande";
  //         this.url00 = reader.result;
  //         this.photoProduit = this.url00;
  //         this.test00 = false;
  //         // console.log( this.url00)
  //       }
  //   }
  // }

  // selectFile01(event: any) {
  //   var mimeType = event.target.files[0].type;
  //   var sizeFile=event.target.files[0].size;
  //   if(!event.target.files[0] || event.target.files[0].length == 0) {
  //     this.msg01 = 'Selectionner une photo';
  //   }
  //   // console.log("size!!!!!")
  //   // console.log(sizeFile)
  //   if(sizeFile<2000000){
  //     // console.log(mimeType);

  //     if (mimeType=="image/jpeg"||mimeType=="image/jpg"||mimeType=="image/png") {

  //       var reader = new FileReader();
  //       reader.readAsDataURL(event.target.files[0]);
  //       reader.onload = (_event) => {
  //         this.msg01 = "";
  //         this.test01 = true;
  //         // alert(this.test)
  //         this.url01 = reader.result;
  //         this.photoProduit1 = this.url01;
  //         // console.log( this.url01);
  //       }
  //     }else{
  //       // this.msg = "Ce type de fichier n'est pas pris en compte.";
  //       var reader = new FileReader();
  //       reader.readAsDataURL(event.target.files[0]);
  //       reader.onload = (_event) => {
  //         this.msg01 = "Ce type de fichier n'est pas pris en compte.";
  //         this.url01 = reader.result;
  //         this.test01 = false;
  //       }
  //     }
  //   }else{
  //     // this.msg = "la taille de l'image est trop grande";
  //     var reader = new FileReader();
  //       reader.readAsDataURL(event.target.files[0]);
  //       reader.onload = (_event) => {
  //         this.msg01 = "La taille de l'image est trop grande";
  //         this.url01 = reader.result;
  //         this.photoProduit1 = this.url01;
  //         this.test01 = false;
  //         // console.log( this.url01)
  //       }
  //   }
  // }

  // selectFile02(event: any) {
  //   var mimeType = event.target.files[0].type;
  //   var sizeFile=event.target.files[0].size;
  //   if(!event.target.files[0] || event.target.files[0].length == 0) {
  //     this.msg02 = 'Selectionner une photo';
  //   }
  //   // console.log("size!!!!!")
  //   // console.log(sizeFile)
  //   if(sizeFile<2000000){
  //     // console.log(mimeType);

  //     if (mimeType=="image/jpeg"||mimeType=="image/jpg"||mimeType=="image/png") {

  //       var reader = new FileReader();
  //       reader.readAsDataURL(event.target.files[0]);
  //       reader.onload = (_event) => {
  //         this.msg02 = "";
  //         this.test02 = true;
  //         // alert(this.test)
  //         this.url02 = reader.result;
  //         this.photoProduit2 = this.url02;
  //         // console.log( this.url02);
  //       }
  //     }else{

  //       // this.msg = "Ce type de fichier n'est pas pris en compte.";
  //       var reader = new FileReader();
  //       reader.readAsDataURL(event.target.files[0]);
  //       reader.onload = (_event) => {
  //         this.msg02 = "Ce type de fichier n'est pas pris en compte.";
  //         this.url02 = reader.result;
  //         this.test02 = false;
  //       }
  //     }
  //   }else{
  //     // this.msg = "la taille de l'image est trop grande";
  //     var reader = new FileReader();
  //       reader.readAsDataURL(event.target.files[0]);
  //       reader.onload = (_event) => {
  //         this.msg02 = "La taille de l'image est trop grande";2
  //         this.url02 = reader.result;
  //         this.photoProduit2 = this.url02;
  //         this.test02 = false;
  //         // console.log( this.url02)
  //       }
  //   }
  // }

  // openFile(){
  //   $('#photo_produit').click();
  // }

  // openFile01(){
  //   $('#photo_produit1').click();
  // }

  // openFile02(){
  //   $('#photo_produit2').click();
  // }

  // openFile1(){
  //   $('#photo_sous_produit').click();
  // }

  // readFile1(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     const file: File = event.target.files[0];
  //     // console.log("file :"+file);
  //     const reader = new FileReader();
  //     reader.onload = (readEvent: any) => {
  //       //console.log("url"+readEvent.target.result);
  //       this.photoSousProduit= readEvent.target.result;
  //       this.validPhotoSubType = this.photoSousProduit;
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // }

  // readFile(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     const file: File = event.target.files[0];
  //     // console.log("file :"+file);
  //     const reader = new FileReader();
  //     reader.onload = (readEvent: any) => {
  //       // console.log("url"+readEvent.target.result);
  //       this.photoProduit = readEvent.target.result;
  //       this.validProductPhoto = this.photoProduit;
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // }

  // //Pour la deuxième photo du produit
  // readFile01(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     const file: File = event.target.files[0];
  //     // console.log("file :"+file);
  //     const reader = new FileReader();
  //     reader.onload = (readEvent: any) => {
  //       // console.log("url"+readEvent.target.result);
  //       this.photoProduit1= readEvent.target.result;
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // }
  // //Pour la troisième photo du produit
  // readFile02(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     const file: File = event.target.files[0];
  //     // console.log("file :"+file);
  //     const reader = new FileReader();
  //     reader.onload = (readEvent: any) => {
  //       // console.log("url"+readEvent.target.result);
  //       this.photoProduit2= readEvent.target.result;
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // }

  // get getProduit() { return this.produitForm.controls; }

  // produitAndVarianteForm = this.fb.group({
  //   produitAndVarianteForm0: this.fb.group({
  //     // name: new FormControl('',{ validators: nameProductValidator('Le nom', 2, 50), updateOn: 'change'} ),
  //     name:  new FormControl('', [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.notOnlyNumber,NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.maxLength(50)]),
  //     category: new FormControl('', Validators.required),
  //     product_type: new FormControl('', Validators.required),
  //     shop: new FormControl('', Validators.required),
  //   }),

  //   produitAndVarianteForm1: this.fb.group({
  //     name: new FormControl('', Validators.required),
  //     characteristic_value: new FormControl('', [ Validators.required,Validators.minLength(1),NameValidator.checkValidOnlyLetterOrNumber]),
  //   }),

  //   produitAndVarianteForm2: this.fb.group({
  //     quantity: new FormControl('', [ Validators.required,Validators.minLength(1),Validators.maxLength(8),NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
  //     price: new FormControl('', [ Validators.required,NameValidator.notOnlyWhitespace,Validators.minLength(3),Validators.maxLength(10),NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$') ]),
  //     threshold: new FormControl('', [ Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
  //   }),

  //   tripExepense: this.fb.array([]) ,
  // });

  // /* Vérifier si les valeurs des champs sont valides */
  // /*¤¤¤¤¤¤¤¤¤¤ Validation du premier formulaire ¤¤¤¤¤¤¤¤¤¤¤¤*/
  // get testName() {return this.produitAndVarianteForm.get('produitAndVarianteForm0.name');}
  // get testCategorie() {return this.produitAndVarianteForm.get('produitAndVarianteForm0.category');}
  // get testProductType() {return this.produitAndVarianteForm.get('produitAndVarianteForm0.product_type');}
  // get testShop() {return this.produitAndVarianteForm.get('produitAndVarianteForm0.shop');}
  // /*¤¤¤¤¤¤¤¤¤¤ ---------------------------- ¤¤¤¤¤¤¤¤¤¤¤¤*/

  // /*¤¤¤¤¤¤¤¤¤¤ Validation du deuxième formulaire ¤¤¤¤¤¤¤¤¤¤¤¤*/
  // get testCaracteristiqueName() {return this.produitAndVarianteForm.get('produitAndVarianteForm1.name');}
  // get testCaracteristiqueValue() {return this.produitAndVarianteForm.get('produitAndVarianteForm1.characteristic_value');}
  // /*¤¤¤¤¤¤¤¤¤¤ ---------------------------- ¤¤¤¤¤¤¤¤¤¤¤¤*/

  // /*¤¤¤¤¤¤¤¤¤¤ Validation du troisième formulaire ¤¤¤¤¤¤¤¤¤¤¤¤*/
  // get testQuantity() {return this.produitAndVarianteForm.get('produitAndVarianteForm2.quantity');}
  // get testPrice() {return this.produitAndVarianteForm.get('produitAndVarianteForm2.price');}
  // get testThreshold() {return this.produitAndVarianteForm.get('produitAndVarianteForm2.threshold');}
  // /*¤¤¤¤¤¤¤¤¤¤ ---------------------------- ¤¤¤¤¤¤¤¤¤¤¤¤*/

  // produitForm = this.fb.group({
  //   name:  new FormControl('', [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.maxLength(50)]),
  //   category: new FormControl('', Validators.required),
  //   product_type: new FormControl('', Validators.required),
  //   shop: new FormControl('', Validators.required),
  //   // quantity: new FormControl('', [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.maxLength(7), Validators.pattern('^[1-9][0-9]*$')]),
  //   // threshold: new FormControl('', [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
  //   // price: new FormControl('',[Validators.required,NameValidator.notOnlyWhitespace,Validators.minLength(3),Validators.maxLength(8),NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
  //   // deliveryDelay: new FormControl('', Validators.required),
  //   // unitDeliveryDuration: new FormControl('', Validators.required),
  //   productCharacteristics: this.fb.array([]) ,
  //   productProductSubTypes: this.fb.array([]) ,
  //   tripExepense: this.fb.array([]) ,
  // });

  // get  productCharacteristics() : FormArray {
  //   return this.produitForm.get("productCharacteristics") as FormArray
  // }
  // get  productSubTypescharacteristique() : FormArray {
  //   return this.produitForm.get("productSubTypescharacteristique") as FormArray
  // }
  // get productProductSubTypes() : FormArray {
  //   return this.produitForm.get("productProductSubTypes") as FormArray
  // }
  // get tripExepense() : FormArray {
  //   return this.produitAndVarianteForm.get("tripExepense") as FormArray
  // }

  // newtripexepense(): FormGroup {
  //   return this.fb.group({
  //     tripExpense:new FormControl('', Validators.required),
  //     price: new FormControl('',[Validators.required,NameValidator.notOnlyWhitespace,Validators.minLength(3),Validators.maxLength(10),NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
  //   })
  // }

  // selectCategorie(val: any):number{
  //   let index = val.target.value;
  //   this.selectedSubCategory = val.target.value;
  //   this.productService.getProductSubtypeCharacteristic(index).subscribe(rs=>{
  //     // console.log("¤¤¤¤¤¤¤¤¤¤¤¤¤")
  //     // console.log(rs);
  //     this.characteristics = rs;
  //   })
  //   this.showCharacteristicProduct = true;
  //   return index;
  // }

  // inputDeliveryDelay(val: any){
  //   let index = parseInt(val.target.value);
  //   if(index != null && index>0){
  //     this.ishiddenDeliveryDdelay = true;
  //   }else if(isNaN(index)){
  //     this.ishiddenDeliveryDdelay = false;
  //   }
  // }

  // isRequiredZone = false;
  // isRequiredPrice = false;
  // addtripexepense() {
  //   if(this.allAUserZones.length > 0) {
  //     this.isRequiredZone = true;
  //     this.isRequiredPrice = true;
  //     this.showProductTripExpense = true;
  //     this.tripExepense.push(this.newtripexepense());
  //   }else{
  //     Swal.fire({
  //       position: 'top-end',
  //       icon: 'error',
  //       title: 'Vous devez définir préalablement la liste des zones que vous couvrez dans votre boutique.',
  //       showConfirmButton: false,
  //       timer: 3500
  //     });
  //   }
  // }

  // removetripexepense(i:number) {
  //   this.productTripeExpenses = this.produitAndVarianteForm.controls['tripExepense'].value;
  //   if(this.productTripeExpenses != null){
  //     if(this.productTripeExpenses.length>1){
  //       this.tripExepense.removeAt(i);
  //     }else if(this.productTripeExpenses.length ==1){
  //       this.showProductTripExpense = false;
  //       this.tripExepense.removeAt(i);;
  //     }
  //   }
  // }

  // removeProductSubTypeTampon(i:number){
  //   this.productSubTypesSaved.splice(i,1);
  //   this.productSubTypesSaved = [...this.productSubTypesSaved];
  //   // console.log("After deleted")
  //   // console.log(this.productSubTypesSaved);
  // }

  // newProductCharacteristics(): FormGroup {
  //   return this.fb.group({
  //     name: new FormControl('', Validators.required),
  //     characteristic_value: new FormControl('', [ Validators.required,Validators.minLength(1),NameValidator.checkValidOnlyLetterOrNumber]),
  //   })
  // }

  // newProductSubTypescharacteristique(): FormGroup {
  //   return this.fb.group({
  //     characteristic: new FormControl('', Validators.required),
  //     default_value: new FormControl('', [ Validators.required,Validators.minLength(1), Validators.pattern(/^-?(0|[1-9]\d*)?$/) ]),
  //   })
  // }
  // quantity:any;
  // subProductFormDis=false;
  // subProductFormDis1=false;
  // productFormDis=false;
  // sumSubProdQt = 0;
  // seuilProdError = false;
  // productQuantityBefore = false;
  // change(val:any){
  //   this.quantity = parseInt(val.target.value);
  //   if(this.seuilSubProd>0){
  //     if(this.quantity < this.seuilSubProd){
  //       this.seuilProdError = true;
  //     }else {
  //       this.testSeuilSubProd = false;
  //     }
  //   }
  // }
  // newProductSubType(): FormGroup {
  //   return this.fb.group({
  //     name:  new FormControl('', [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.maxLength(50)]),
  //     quantity: new FormControl('', [ Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
  //     price: new FormControl('', [ Validators.required,NameValidator.notOnlyWhitespace,Validators.minLength(3),Validators.maxLength(10),NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$') ]),
  //     threshold: new FormControl('', [ Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.pattern('^[1-9][0-9]*$')]),
  //   })
  // }
  // getCategory(id:any) :Category {
  //   let category:Category = new Category();
  //   this.categories.forEach(element => {
  //     if(element.id == id) {
  //       category = element;
  //     }
  //   })
  //   return category;
  // }
  // getSubCategory(id:any) :IProductType {
  //   let product_type:ProductType = new ProductType();
  //   this.productTypes.forEach(element => {
  //     if(element.id == id) {
  //       product_type = element;
  //     }
  //   })
  //   return product_type;
  // }
  // getShop(id:any) :Shop {
  //   let myshop:Shop = new Shop();
  //   this.shop.forEach(element => {
  //     if(element.id == id) {
  //       myshop = element;
  //     }
  //   })
  //   return  myshop;
  // }

  // getTrip(id:any) :TripExpense{
  //   let trip:TripExpense = new TripExpense();
  //   this.trip_ExpenseModel.forEach(element => {
  //     // console.log(element.zone?.id + "==" + id)
  //     if(element.zone?.id == id) {
  //       trip = element;
  //     }
  //   })
  //   return trip;
  // }

  // // getTrip(id:any) :TripExpense{
  // //   let trip:Zone = new Zone();
  // //   this.trip_ExpenseModel.forEach(element => {
  // //     if(element.id == id) {
  // //       trip = element;
  // //     }
  // //   })
  // //   return trip;
  // // }

  // getCharacteristic(id:any) :Characteristics {
  //   let  characteristic:Characteristics = new Characteristics();
  //   this.characteristics.forEach(element => {
  //     if(element.id == id) {
  //       characteristic = element;
  //     }
  //   })
  //   return characteristic;
  // }

  // getproductSubType(id:any) :IProductSubType {
  //   let   productSType:ProductSubType = new ProductSubType();
  //   this.productSubs.forEach(element => {
  //     if(element.id == id) {
  //       productSType= element;
  //     }
  //   })
  //   return  productSType;
  // }

  // addProductCharacteristics() {
  //   this.showCharacteristicProduct = true;
  //   this.productCharacteristics.push(this.newProductCharacteristics());
  // }

  // addProductSubTypescharacteristique() {
  //   this.productSubTypescharacteristique.push(this.newProductSubTypescharacteristique());
  // }

  // disabledSavedProduct = false;
  // addProductSubType() {
  //   this.showProductSubType = true;
  //   this.showProductSubTypeButton = false;
  //   this.productProductSubTypes.push(this.newProductSubType());
  //   this.disabledSavedProduct = true;
  // }

  // // for saving product subtype
  // validName: any;
  // validQuantity: any;
  // validPrice: any;
  // validAlertStock: any;
  // validProductPhoto:any;
  // validPhotoSubType: any;
  // validCharacteristic: any;
  // validCharacteristicValue: any;
  // msg!:string;
	// msg00!:string;
	// msg01!:string;
	// msg02!:string;
  // test00=false;
  // test01=false;
  // test02=false;
  // test03=false;
  // url00: any;
  // url01: any;
  // url02: any;
  // saveProductSubType(){
  //   this.validProductPhoto = this.photoProduit;
  //   let subProduct = new SubProduct();
  //   let sbProdCharact:any[]=[];
  //   //productSubtypeArrayTampon
  //   this.productSubTypeCharacteristicsForm = this.produitForm.controls['productCharacteristics'].value;
  //   if(this.productProductSubTypes.status == 'VALID' && (this.photoProduit != '' || this.photoProduit1 != '' || this.photoProduit2 != '')){
  //     if(this.productSubTypeCharacteristicsForm != null && this.productSubTypeCharacteristicsForm.length>0){
  //       for(const prodCharacteristic of this.productCharacteristics.controls){
  //         this.validCharacteristic = prodCharacteristic.get('characteristic')?.status;
  //         this.validCharacteristicValue = prodCharacteristic.get('characteristic_value')?.status;
  //       }
  //       if(this.productCharacteristics.status == 'VALID'){
  //         this.productSubTypesForm = this.produitForm.controls['productProductSubTypes'].value;
  //         this.productSubTypeCharacteristicsForm = this.produitForm.controls['productCharacteristics'].value;
  //         if(this.productSubTypesForm != null){
  //           this.productSubTypesForm.forEach(elementAt=>{
  //             // console.log("Acces photo sous type");
  //             // console.log(this.photoSousProduit);
  //             subProduct.photoTampon = this.photoProduit;
  //             subProduct.photo = this.photoProduit;
  //             if(this.photoProduit1){
  //               subProduct.photo1 = this.photoProduit1;
  //             }
  //             if(this.photoProduit2){
  //               subProduct.photo2 = this.photoProduit2;
  //             }
  //             subProduct.name = elementAt.name;
  //             subProduct.price = elementAt.price;
  //             subProduct.quantity = elementAt.quantity;
  //             subProduct.threshold = elementAt.threshold;
  //             if(this.productSubTypeCharacteristicsForm != null){
  //               this.productSubTypeCharacteristicsForm.forEach(element =>{
  //                 // console.log("Afffichage des éléements.................")
  //                 // console.log(element)
  //                 let sbProductCharacteristic = new SubProductCharacteristic();
  //                 let characteristic = new Characteristics();
  //                 characteristic.characteristic_value = element.characteristic_value;
  //                 sbProductCharacteristic.characteristic = this.getCharacteristic(element.name);
  //                 sbProductCharacteristic.value = element.characteristic_value;
  //                 sbProdCharact.push(sbProductCharacteristic);
  //               })
  //             }
  //             this.productQuantity = this.productQuantity-this.quantity;
  //             subProduct.subProductCharacteristics = sbProdCharact;
  //             this.productSubTypesSaved.push(subProduct);
  //             this.disabledSavedProduct = false;
  //           })
  //           this.photoSousProduit = "";
  //         }
  //         // Remove product subtype
  //         if(this.productSubTypesForm.length>=1){
  //           for(let i in this.productSubTypesForm){
  //             this.showProductSubTypeButton = true;
  //             this.productProductSubTypes.removeAt(Number(i));
  //             this.showProductSubType = false;
  //           }
  //         }
  //         // Remove product subtype characteristique
  //         if(this.productSubTypeCharacteristicsForm.length>=1){
  //           for(let i in this.productSubTypeCharacteristicsForm){
  //             this.showCharacteristicProduct = false;
  //             this.productCharacteristics.removeAt(Number(i));
  //           }
  //         }
  //       }
  //       // console.log("================================")
  //       // console.log(this.productSubTypesSaved);
  //     }else{
  //       //Si le sous-produit n'a pas de caractèristique
  //       this.productSubTypesForm = this.produitForm.controls['productProductSubTypes'].value;
  //         if(this.productSubTypesForm != null){
  //           this.productSubTypesForm.forEach(elementAt=>{
  //             // console.log("Acces photo sous type");
  //             // console.log(this.photoSousProduit);
  //             subProduct.photoTampon = this.photoProduit;
  //             subProduct.photo = this.photoProduit;
  //             if(this.photoProduit1){
  //               subProduct.photo1 = this.photoProduit1;
  //             }
  //             if(this.photoProduit2){
  //               subProduct.photo2 = this.photoProduit2;
  //             }
  //             subProduct.name = elementAt.name;
  //             subProduct.price = elementAt.price;
  //             subProduct.quantity = elementAt.quantity;
  //             subProduct.threshold = elementAt.threshold;
  //             //On mait à jour la quantitée avant d'enregistrer dans le tableau
  //             this.productQuantity = this.productQuantity-this.quantity;
  //             this.productSubTypesSaved.push(subProduct);
  //             this.disabledSavedProduct = false;
  //           })
  //           this.photoSousProduit = "";
  //         }
  //         // Remove product subtype
  //         if(this.productSubTypesForm.length>=1){
  //           for(let i in this.productSubTypesForm){
  //             this.showProductSubTypeButton = true;
  //             this.productProductSubTypes.removeAt(Number(i));
  //             this.showProductSubType = false;
  //           }
  //         }
  //         // Remove product subtype characteristique
  //         if(this.productSubTypeCharacteristicsForm.length>=1){
  //           for(let i in this.productSubTypeCharacteristicsForm){
  //             this.showCharacteristicProduct = false;
  //             this.productCharacteristics.removeAt(Number(i));
  //           }
  //         }
  //     }

  //     // console.log("Saved product");
  //     // console.log(this.productSubTypesSaved);
  //   }else{
  //     for(const subProd of this.productProductSubTypes.controls){
  //       this.validPhotoSubType = this.photoSousProduit;
  //       this.validName = subProd.get('name')?.status;
  //       this.validQuantity = subProd.get('quantity')?.status;
  //       this.validPrice = subProd.get('price')?.status;
  //       this.validAlertStock = subProd.get('threshold')?.status;
  //     }
  //     if(this.productSubTypeCharacteristicsForm != null && this.productSubTypeCharacteristicsForm.length>0){
  //       for(const prodCharacteristic of this.productCharacteristics.controls){
  //         this.validCharacteristic = prodCharacteristic.get('name')?.status;
  //         this.validCharacteristicValue = prodCharacteristic.get('characteristic_value')?.status;
  //       }
  //     }
  //   }
  // }

  // saveProductSubTypeAndCaracteristique(){
  //   this.validProductPhoto = this.photoProduit;
  //   if(this.validProductPhoto != ''){
  //     let subProduct = new SubProduct();
  //     if(this.produitAndVarianteForm.controls.produitAndVarianteForm0.invalid){
  //       this.produitAndVarianteForm.controls.produitAndVarianteForm0.markAllAsTouched();
  //       this.produitAndVarianteForm.controls.produitAndVarianteForm1.markAsUntouched();
  //       this.produitAndVarianteForm.controls.produitAndVarianteForm2.markAsUntouched();
  //       return;
  //     }else{
  //       if(this.produitAndVarianteForm.controls.produitAndVarianteForm2.invalid){
  //         this.produitAndVarianteForm.controls.produitAndVarianteForm0.markAsUntouched();
  //         this.produitAndVarianteForm.controls.produitAndVarianteForm1.markAsUntouched();
  //         this.produitAndVarianteForm.controls.produitAndVarianteForm2.markAllAsTouched();
  //         return;
  //       }else{
  //         let productInitForm = this.produitAndVarianteForm.controls['produitAndVarianteForm0'].value;
  //         let productSubTypeForms = this.produitAndVarianteForm.controls['produitAndVarianteForm2'].value;
  //         if(this.productSubTypeForms != null){
  //           subProduct.photoTampon = this.photoProduit;
  //           subProduct.photo = this.photoProduit;
  //           if(this.photoProduit1){
  //             subProduct.photo1 = this.photoProduit1;
  //           }
  //           if(this.photoProduit2){
  //             subProduct.photo2 = this.photoProduit2;
  //           }
  //           subProduct.name = productInitForm.name;
  //           subProduct.price = productSubTypeForms.price;
  //           subProduct.quantity = productSubTypeForms.quantity;
  //           subProduct.threshold = productSubTypeForms.threshold;
  //           subProduct.subProductCharacteristics = this.caracteristiquesVariante;
  //           this.productSubTypesSaved.push(subProduct);
  //           this.caracteristiquesVarianteTmp = [];
  //         }
  //         this.caracteristiquesVariante = [];
  //         this.photoProduit = "";
  //         this.photoProduit1 = "";
  //         this.photoProduit2 = "";
  //         this.produitAndVarianteForm?.get('produitAndVarianteForm2')?.reset();
  //       }
  //     }
  //   }else{
  //     Swal.fire({
  //       position: 'top-end',
  //       icon: 'error',
  //       title: 'Veuillez ajouter une photo s\'il vous plaît.',
  //       showConfirmButton: false,
  //       timer: 2500
  //     });
  //   }
  // }

  // saveProductCarateristics(){
  //   let sbProdCharact:any[]=[];
  //   let isAllreadySaved = false;
  //   if(this.caracteristiquesVariante.length >0){
  //     if(this.produitAndVarianteForm.controls.produitAndVarianteForm1.invalid){
  //       this.produitAndVarianteForm.controls.produitAndVarianteForm0.markAsUntouched();
  //       this.produitAndVarianteForm.controls.produitAndVarianteForm2.markAsUntouched();
  //       this.produitAndVarianteForm.controls.produitAndVarianteForm1.markAllAsTouched();
  //       return;
  //     }else{
  //       let productSubTypeCharacteristicsForm = this.produitAndVarianteForm.controls['produitAndVarianteForm1'].value;
  //       this.caracteristiquesVarianteTmp.forEach(element => {
  //         if(element.characteristic.id === Number(productSubTypeCharacteristicsForm.name)){
  //           isAllreadySaved = true;
  //         }
  //       });
  //       if(isAllreadySaved){
  //         Swal.fire({
  //           position: 'top-end',
  //           icon: 'error',
  //           title: 'Vous avez déjà ajouté cette caractéristique',
  //           showConfirmButton: false,
  //           timer: 2500
  //         })
  //       }else{
  //         if(this.productSubTypeCharacteristicsForm != null){
  //           // console.log(" Test valuesssss ");
  //           // console.log(this.caracteristiquesVarianteTmp);
  //           let sbProductCharacteristic = new SubProductCharacteristic();
  //           let characteristic = new Characteristics();
  //           characteristic.characteristic_value = productSubTypeCharacteristicsForm.characteristic_value;
  //           sbProductCharacteristic.characteristic = this.getCharacteristic(productSubTypeCharacteristicsForm.name);
  //           sbProductCharacteristic.value = productSubTypeCharacteristicsForm.characteristic_value;
  //           sbProdCharact.push(sbProductCharacteristic);
  //           this.caracteristiquesVariante.push(sbProductCharacteristic);
  //           this.caracteristiquesVarianteTmp.push(sbProductCharacteristic);
  //           this.addProductSubType();
  //           this.produitAndVarianteForm?.get('produitAndVarianteForm1')?.reset()
  //         }
  //         // console.log("Caractéristique du formulaire d'ajout de produit")
  //         // console.log(this.caracteristiquesVariante);
  //       }
  //     }
  //   }else{
  //     // Si c'est la première caractéristique ajoutée
  //     if(this.produitAndVarianteForm.controls.produitAndVarianteForm1.invalid){
  //       this.produitAndVarianteForm.controls.produitAndVarianteForm0.markAsUntouched();
  //       this.produitAndVarianteForm.controls.produitAndVarianteForm2.markAsUntouched();
  //       this.produitAndVarianteForm.controls.produitAndVarianteForm1.markAllAsTouched();
  //       return;
  //     }else{
  //       let productSubTypeCharacteristicsForm = this.produitAndVarianteForm.controls['produitAndVarianteForm1'].value;

  //       if(this.productSubTypeCharacteristicsForm != null){
  //         let sbProductCharacteristic = new SubProductCharacteristic();
  //         let characteristic = new Characteristics();
  //         characteristic.characteristic_value = productSubTypeCharacteristicsForm.characteristic_value;
  //         sbProductCharacteristic.characteristic = this.getCharacteristic(productSubTypeCharacteristicsForm.name);
  //         sbProductCharacteristic.value = productSubTypeCharacteristicsForm.characteristic_value;
  //         sbProdCharact.push(sbProductCharacteristic);
  //         this.caracteristiquesVariante.push(sbProductCharacteristic)
  //         this.caracteristiquesVarianteTmp.push(sbProductCharacteristic);
  //         this.addProductSubType();
  //         // Remove product subtype characteristique
  //         // if(this.productSubTypeCharacteristicsForm.length>=1){
  //         //   for(let i in this.productSubTypeCharacteristicsForm){
  //         //     this.showCharacteristicProduct = true;
  //         //     this.productCharacteristics.removeAt(Number(i));
  //         //   }
  //         // }
  //         this.produitAndVarianteForm?.get('produitAndVarianteForm1')?.reset()
  //       }
  //       // console.log("Caractéristique du formulaire d'ajout de produit")
  //       // console.log(this.caracteristiquesVariante);
  //     }
  //   }

  // }

  // changeName(val){
  //   let index = val.target.value;
  //   if(index && index !=''){
  //     this.validName = '';
  //   }
  // }
  // changeQuantity(val){
  //   let index = val.target.value;
  //   if(index && index !=''){
  //     this.validQuantity = '';
  //   }
  // }
  // changePrice(val){
  //   let index = val.target.value;
  //   if(index && index !=''){
  //     this.validPrice = '';
  //   }
  // }
  // changeAlertStock(val){
  //   let index = val.target.value;
  //   if(index && index !=''){
  //     this.validAlertStock = '';
  //   }
  // }

  // removeProductCharacteristics(i:number): void {
  //   if(i >= 0 && i < this.caracteristiquesVariante.length){
  //     this.caracteristiquesVariante.splice(i,1);
  //     this.caracteristiquesVarianteTmp = this.caracteristiquesVariante;
  //     this.caracteristiquesVariante = [...this.caracteristiquesVariante];
  //   }
  //   // this.productSubTypeCharacteristics = this.produitForm.controls['productCharacteristics'].value;
  //   // if(this.productSubTypeCharacteristics != null){
  //   //   if(this.productSubTypeCharacteristics.length>1){
  //   //     this.productCharacteristics.removeAt(i);
  //   //   }else if(this.productSubTypeCharacteristics.length ==1){
  //   //     this.showCharacteristicProduct = false;
  //   //     this.productCharacteristics.removeAt(i);
  //   //   }
  //   // }
  // }

  // removeProductSubTypescharacteristique(i:number) {
  //   this.productSubTypescharacteristique.removeAt(i);
  // }
  // removeProductSubType(i:number) {
  //   this.showProductSubType = false;
  //   this.showCharacteristicProduct = false;
  //   this.productSubTypeCharacteristics = this.produitForm.controls['productCharacteristics'].value;
  //   if(this.productSubTypeCharacteristics.length > 0){
  //     for(let j=0; j<this.productSubTypeCharacteristics.length; j++){
  //       this.productCharacteristics.removeAt(j);
  //     }
  //   }
  //   //Show ProductSubtypeButtton
  //   this.showProductSubTypeButton = true;
  //   this.productProductSubTypes.removeAt(i);
  //   this.disabledSavedProduct = false;
  //   // alert("Finale lenfth"+this.productSubTypeCharacteristics.length)

  // }

  // mettreatrue  = false;
  // testRequiredValue(){
  //   this.mettreatrue = true;
  // }


  // onFormSubmit(): void{
  //   if(!this.isTrueName){
  //     let newproduit= new Product();
  //     if(this.productSubTypesSaved.length>0){
  //       if(this.produitAndVarianteForm.controls.produitAndVarianteForm0.invalid){
  //         this.produitAndVarianteForm.controls.produitAndVarianteForm0.markAllAsTouched();
  //         this.produitAndVarianteForm.controls.produitAndVarianteForm1.markAsUntouched();
  //         this.produitAndVarianteForm.controls.produitAndVarianteForm2.markAsUntouched();
  //         return;
  //       }else{
  //         //let productSubTypeCharacteristicsForm = this.produitAndVarianteForm.controls['produitAndVarianteForm1'].value;
  //         this.tripExpenseList = this.produitAndVarianteForm.controls['tripExepense'].value;
  //         this.tripExpenseList.forEach(element => {
  //           if(element.tripExpense && element.price){
  //             let productDeliveryZones = new ProductDeliveryZones();
  //             productDeliveryZones.userZone = this.getUserZone(element.tripExpense);
  //             productDeliveryZones.price = element.price;
  //             this.productDeliveryZonesList.push(productDeliveryZones);
  //           }
  //         });
  //         let productInitForm = this.produitAndVarianteForm.controls['produitAndVarianteForm0'].value;
  //         newproduit.name = productInitForm.name;
  //         newproduit.category = this.getCategory(productInitForm.category);
  //         newproduit.product_type=this.getSubCategory(productInitForm.product_type);
  //         newproduit.shop=this.getShop(productInitForm.shop);

  //         newproduit.subProducts=this.productSubTypesSaved;
  //         // newproduit.tripExpenseProducts=this.myTripExpense;
  //         newproduit.productDeliveryZones=this.productDeliveryZonesList;

  //         this.produitService.saveProduct(newproduit).subscribe(rs=>{
  //           // console.log("Produit enregistrer")
  //           // console.log(rs)

  //           this.disableButtonValider = false;
  //           document.getElementById("btnCloseModalEditProduct")?.click();
  //           this.produitForm.reset();
  //           this.loadProduct_v1();
  //           this.reloadComponent();
  //           Swal.fire({
  //             position: 'top-end',
  //             icon: 'success',
  //             title: 'Votre produit a été enregistré avec succès.',
  //             showConfirmButton: false,
  //             timer: 1500
  //           });
  //         }, error => {
  //           this.disableButtonValider = false;
  //           newproduit= new Product();
  //           Swal.fire({
  //             position: 'top-end',
  //             icon: 'error',
  //             title: 'Erreur d\'ajout <br>'+error.error.errorMessage,
  //             showConfirmButton: false,
  //             timer: 1500
  //           })
  //         });
  //       }
  //     }else{
  //       Swal.fire({
  //         position: 'top-end',
  //         icon: 'error',
  //         title: 'Vous devez rajouter au moins un modèle de produit.',
  //         showConfirmButton: false,
  //         timer: 5000
  //       });
  //     }
  //   }
  // }

  // getUserZone(id:any) : UserZone{
  //   let userzone : UserZone = new UserZone();
  //   this.allAUserZones.forEach(element => {
  //     // console.log(element.zone?.id + "==" + id)
  //     if(element?.id == id) {
  //       userzone = element;
  //     }
  //   })
  //   return userzone;
  // }

  // public onClose(): void {
  //   this.modalService.hide();
  // }

  // reloadComponent() {
  //   let currentUrl = this.router.url;
  //   this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  //   this.router.onSameUrlNavigation = 'reload';
  //   this.router.navigate([currentUrl]);
  // }
  // sort1() {
  //   if(this.sorted1 == false) {
  //     // @ts-ignore
  //     this.allProducts.sort((a, b) => -1 * a.name.localeCompare(b.name))
  //     this.sorted1 = true;
  //   } else {
  //     // @ts-ignore
  //     this.allProducts.sort((a, b) => 1 * a.name.localeCompare(b.name))
  //     this.sorted1 = false;
  //   }
  // }
  // sort2() {
  //   if(this.sorted2 == false) {
  //     // @ts-ignore
  //     this.allProducts.sort((a, b) => a.productID > b.productID ? 1 : a.productID < b.productID ? -1 : 0)
  //     this.sorted2 = true;
  //   } else {
  //     // @ts-ignore
  //     this.allProducts.sort((a, b) => a.productID < b.productID ? 1 : a.productID > b.productID ? -1 : 0)
  //     this.sorted2 = false;
  //   }
  // }

  // sort3() {
  //   if(this.sorted3 == false) {
  //     // @ts-ignore
  //     this.allProducts.sort((a, b) => a.shop?.shopID > b.shop?.shopID ? 1 : a.shop?.shopID < b.shop?.shopID ? -1 : 0)
  //     this.sorted3 = true;
  //   } else {
  //     // @ts-ignore
  //     this.allProducts.sort((a, b) => a.shop?.shopID < b.shop?.shopID ? 1 : a.shop?.shopID > b.shop?.shopID ? -1 : 0)
  //     this.sorted3 = false;
  //   }
  // }
  // sort4() {
  //   if(this.sorted4 == false) {
  //     // @ts-ignore
  //     this.allProducts.sort((a, b) => a.shop?.name > b.shop?.name ? 1 : a.shop?.name < b.shop?.name ? -1 : 0)
  //     this.sorted4 = true;
  //   } else {
  //     // @ts-ignore
  //     this.allProducts.sort((a, b) => a.shop?.name < b.shop?.name ? 1 : a.shop?.name > b.shop?.name ? -1 : 0)
  //     this.sorted4 = false;
  //   }
  // }
  // sort() {
  //   if(this.sorted == false) {
  //     // @ts-ignore
  //     this.allProducts.sort((a, b) => a.category?.name > b.category?.name ? 1 : a.category?.name < b.category?.name ? -1 : 0)
  //     this.sorted = true;
  //   } else {
  //     // @ts-ignore
  //     this.allProducts.sort((a, b) => a.category?.name < b.category?.name ? 1 : a.category?.name > b.category?.name ? -1 : 0)
  //     this.sorted = false;
  //   }
  // }

  // sort5() {
  //   if(this.sorted5 == false) {
  //     // @ts-ignore
  //     this.allProducts.sort((a, b) => a.product_type?.name > b.product_type?.name ? 1 : a.product_type?.name < b.product_type?.name ? -1 : 0)
  //     this.sorted5 = true;
  //   } else {
  //     // @ts-ignore
  //     this.allProducts.sort((a, b) => a.product_type?.name < b.product_type?.name ? 1 : a.product_type?.name > b.product_type?.name ? -1 : 0)
  //     this.sorted5 = false;
  //   }
  // }

  // getPhotoProduct(product : any){
  //   if(product?.postProducts){
  //     return product?.postProducts[0]?.product?.photo;
  //   }
  // }

  // strUcFirst(valeur : any){return (valeur+'').charAt(0).toUpperCase()+valeur.substr(1);}

}
